<table class="utilization-in-period-table" width="100%">
    <thead>
    <tr class="c-text--dark-gray c-text--sm">
        <th scope="col">{{'Hr_Dashboard.Services' | translate}}</th>
        <th scope="col" style="text-align: center;">{{'Hr_Dashboard.Table_Hr_Invitations.Count' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr>
        <td colspan="3" class="divider">
            <hr />
        </td>
    </tr>
    <tr class="c-text--sm">
        <th scope="row">{{ 'Hr_Dashboard.Session_Conducted' | translate }}</th>
        <td>
            <div style="display: flex; justify-content: center">
                <div style="margin-right: 5px">{{(vm.getReportSessionDescriptor('COMPLETED')['psychoSessionCount'] || 0) + (vm.getReportSessionDescriptor('COMPLETED')['coachSessionCount'] || 0)}}</div>
                <div *ngIf="(vm.getReportSessionDescriptor('COMPLETED')['changeComparedToLastPeriod'] || 0) >= 0" style="background-color: rgba(181, 224, 195, 0.3);color: #216b1f"> &#8593; +{{vm.getReportSessionDescriptor('COMPLETED')['changeComparedToLastPeriod'] || 0}}%</div>
                <div *ngIf="(vm.getReportSessionDescriptor('COMPLETED')['changeComparedToLastPeriod'] || 0) < 0" style="background-color: rgba(208,1,0,0.16);color: #750000;"> &#8595;{{vm.getReportSessionDescriptor('COMPLETED')['changeComparedToLastPeriod'] || 0}}%</div>
            </div>
        </td>
    </tr>
    <tr class="c-text--sm">
        <th scope="row">{{ 'Hr_Dashboard.Employees' | translate }}</th>
        <td>{{vm.generatedPreview ? vm.generatedPreview.usersWhoUsedInPeriodCount || 0 : 0}}</td>
    </tr>
    <tr class="c-text--sm">
        <th scope="row">{{ 'Hr_Dashboard.Employees_Used_Any_MH_Service' | translate }}</th>
        <td>{{vm.generatedPreview ? vm.generatedPreview.usersWhoUsedAnyMHService || 0 : 0}}</td>
    </tr>
    </tbody>
</table>
